
import Vue from 'vue'
import Config from '@/config'
import EduSSO from './EduSSO'
import EduSSOConfig from './EduSSOConfig'
import LoginHelper, { UserInfo } from './LoginHelper'
import defaultAvatar from '@/assets/avatar.png'

function setcookie(cookieName, cookieValue, seconds?, path?, domain?, secure?) {
  debugger
  console.log('setcookie', cookieName, cookieValue, seconds, path, domain, secure);
  var expires = new Date()
  if (cookieValue == '' || seconds < 0) {
    cookieValue = ''
    seconds = -2592000
  }
  expires.setTime(expires.getTime() + seconds * 1000)
  domain = ''
  path = '/'
  document.cookie =
    escape(cookieName) +
    '=' +
    escape(cookieValue) +
    (expires ? '; expires=' + expires.toUTCString() : '') +
    (path ? '; path=' + path : '/') +
    (domain ? '; domain=' + domain : '') +
    (secure ? '; secure' : '')
}

export default Vue.extend({
  props: {
    system: String,
  },
  data() {
    return {
      user: {
        realName: '',
        userId: 0,
        avatar: {
          avatar_small: defaultAvatar,
        },
        userPhoto: '',
      } as UserInfo,
      isFirst:true
    }
  },
  computed: {
    isLogin(): boolean {
      return this.user.userId !== 0 
    },
    loginUrl(): string {
      const host = Config.getHost()
      console.log("host",host)
      if (Config.env === 'test') {
        debugger
        // const usp = new URLSearchParams()
        // usp.append('app', 'resource')
        // usp.append('mod', 'Index')
        // usp.append('act', 'index')
        // return host + '/EduResource/index.php?' + usp.toString()
        return host + '/home/#/login'
      } else {
        return host + '/#/login'
      }
    },
  },
  mounted() {
    debugger
   console.log("222")
    LoginHelper.getUser().then((user: UserInfo) => {
      LoginHelper.isLogin = false;
      this.user = user
      debugger 
      
      if ( this.user.realName!=undefined && this.user.realName!="") {
        
        LoginHelper.isLogin = true;
       
                if ( this.user.realName.length > 4) {
                  this.user.realName = `${ this.user.realName.substring(0, 4)}..`;
                }
              

              this.user.userPhoto =
              this.user.userPhoto ||
              'https://ah.download.ahedu.cn/rrt/sns/data/upload/addons_theme_stv1_static_image/noavatar/middle.jpg'
            }

      // if (!this.user.avatar.avatar_small) {
      //   this.user.avatar.avatar_small = defaultAvatar
      // }
    })
  },
  methods: {
    getUserInfo() {
      LoginHelper.getUser().then((user: UserInfo) => {
      
        if (user.userId == 0) {
          if(this.isFirst){
            this.isFirst = false;
            this.getUserInfo();
          }
        } else {
          LoginHelper.isLogin = true
          this.user = user

          if (!this.user.avatar.avatar_small) {
            this.user.avatar.avatar_small = defaultAvatar
          }
        }
      })
    },
    onAvatarError() {
     // this.user.avatar.avatar_small = defaultAvatar
     this.getUserInfo()
    },
    logout() {
      const config = Config.env === 'test' ? EduSSOConfig.test : EduSSOConfig.prod
      const sso = new EduSSO(config.serviceUrl, config.SSOServerUrlLocal, config.SSOServerUrlCenter,config.zpSession)
    
      sso.logout(() => {
        if (/^zhszpj/.test(location.host)) {
          sso.logoutzp(() => {
            setcookie('al', 0)
            setcookie('isLogin', 0)
            // setcookie('SSOSessionId', 0) 
            this.$emit('logout')
            // window.location.reload();
            window.location.href = config.loginUrl
          });
        } else {
          setcookie('al', 0)
          setcookie('isLogin', 0)
          // setcookie('SSOSessionId', 0) 
          this.$emit('logout')
          window.location.reload();
          // window.location.href = config.loginUrl
        }
      })
    },
  },
})
